<div class="edit-orders-content">
  <mat-list>
    <mat-list-item *ngFor="let e of files">
      <div class="row-layout">
        <div style="width: 20rem">{{e.name}}</div>
        <div><button mat-button (click)="show(e)">Anzeigen</button></div>
      </div>
    </mat-list-item>
  </mat-list>
</div>
